<template>

  <article :class="['tes-article', 'tes-article_page']"
           itemscope itemtype="http://schema.org/Article">


    <meta  itemprop="mainEntityOfPage" itemscope itemtype="https://schema.org/WebPage"
          :itemid="`https://tion.ru${page.path()}`" :content="page.header()">

    <header class="tes-article__header">
      <h1 class="tes-article__header-title"
          itemprop="headline"
          v-html="page.header()"></h1>
    </header>

    <div class="tes-article__introduction">
      <div
        :class="{
          'tes-article__introduction-icon-wrapper':true,
          'tes-article__introduction-icon-wrapper_style': page.icon() && page.icon().id() && page.icon().type() !== 'storage'
          }" v-if="page.icon() && page.icon().type() === 'storage'">
        <IconView class="tes-article__introduction-icon" iconClass="tes-article__introduction-icon-image"
                  :icon="page.icon()" v-if="page.icon() && page.icon().id()" />
        <StarYellowIcon class="tes-article__introduction-icon" width="40" height="38" v-else/>
      </div>
      <span>
        <meta itemprop="datePublished" :content="page.publishedAtIso()">
        <meta itemprop="dateModified" :content="page.updatedAtIso()">
      </span>
      <div class="tes-article__introduction-content"
           itemprop="description"
           v-html="page.introduction()"></div>
    </div>

    <nav class="tes-article__theses" v-if="page.hasTheses()">
      <h2 class="tes-article__theses-list-header">Содержание:</h2>
      <ul class="tes-article__theses-list"
          itemprop="articleSection">
        <li class="tes-article__theses-list-item" v-for="thesis in page.theses()">
          <a :href="thesis.anchor()" class="tes-article__thesis-link"><span
            class="tes-article__thesis-link">{{ thesis.title() }}</span></a>
          <ul v-if="thesis.hasTheses()">
            <li class="tes-article__theses-list-item" v-for="subTheses in thesis.theses()">
              <a :href="subTheses.anchor()" class="tes-article__thesis-link"><span
                class="tes-article__thesis-link">{{ subTheses.title() }}</span></a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>

    <div class="tes-article__body" itemprop="articleBody"
         v-for="(contentData, index) in page.content()"
    >
      <component :item="contentData.content()"
                 :index="index"
                 :sortNum="contentData.sortNum()"
                 :lazy="contentData.lazy()"
                 :header="contentData.header()"
                 :more="contentData.more()"
                 :is="loadContentComponent(contentData)"/>
    </div>

    <ItemPropPublisherDefaultView/>

  </article>

</template>

<script lang="ts">

import {PageContentInterface, PageInterface} from "../../objects/Page";

import {PropType} from 'vue'

import IconView from '../icon/IconView.vue'
import ItemPropPublisherDefaultView from '../include/ItemPropPublisherDefaultView.vue'
import PageTextView from './contents/PageTextView.vue'

import CommentBarsIcon from '~/assets/icons/comment_bars.svg'
import EyeIcon from '~/assets/icons/eye.svg'
import Rating12PlusIcon from '~/assets/icons/age-ratings/12-plus.svg'
import StarYellowIcon from '~/assets/icons/star-yellow.svg'
import PuffSpinner from '~/assets/loaders/puff.svg'


export default {
  name: 'PageView',
  components: {
    IconView,
    ItemPropPublisherDefaultView,
    PageTextView,
    CommentBarsIcon,
    EyeIcon,
    Rating12PlusIcon,
    StarYellowIcon,
    PuffSpinner
  },
  props: {
    page: {
      type: Object as PropType<PageInterface>,
      required: true
    },
  },
  setup() {

    const loadContentComponent = (contentData: PageContentInterface) => {
      if (contentData.type() === 'page-text') {
        return PageTextView
        //return defineAsyncComponent(() => import('./contents/PageTextView.vue'))
      }
      return null;
    }

    return {loadContentComponent}
  }
}
</script>
